module.exports = __webpack_public_path__ + "static/img/page3-main.0744c5d9.png";